// Accessibility patches for Popup Maker markup, which we don't control.
//
// 1. `.pum-content` ships with tabindex="0" but no interactive role, failing
//    the "focusable elements need an appropriate role" audit. It isn't
//    interactive, so we drop it from the tab order (tabindex -1). It stays
//    programmatically focusable, so Popup Maker's focus-on-open still works.
//
// 2. The `.pum-overlay` gets role="dialog"/aria-modal at runtime but no
//    accessible name, failing the "dialog needs a descriptive name" audit.
//    We point aria-labelledby at the popup's own heading (or fall back to a
//    generic label).
const PopupAccessibility = (($) => {
  const _fixContentFocus = () => {
    $('.pum-content[tabindex="0"]').attr('tabindex', '-1');
  };

  const _nameDialogs = () => {
    $('.pum-overlay').each(function () {
      const $overlay = $(this);

      if ($overlay.attr('aria-label') || $overlay.attr('aria-labelledby')) {
        return;
      }

      // Prefer the popup's own title, then the first content heading.
      let $title = $overlay.find('.pum-title, .popmake-title').first();
      if (!$title.length) {
        $title = $overlay.find('.pum-content').find('h1, h2, h3, h4, h5, h6').first();
      }

      if ($title.length && $.trim($title.text())) {
        let titleId = $title.attr('id');
        if (!titleId) {
          titleId = ($overlay.attr('id') || 'pum') + '-title';
          $title.attr('id', titleId);
        }
        $overlay.attr('aria-labelledby', titleId);
      } else {
        $overlay.attr('aria-label', 'Popup dialog');
      }
    });
  };

  const _fix = () => {
    _fixContentFocus();
    _nameDialogs();
  };

  const init = () => {
    if (!$('.pum-overlay').length) {
      return;
    }

    _fix();

    // Re-apply if Popup Maker re-renders when a popup opens.
    $(document).on('pumInit pumAfterOpen', '.pum', _fix);
  };

  module.exports = {
    init: init,
  };
})(jQuery);
